import _Vue from 'vue'
import Vuex from 'vuex'
_Vue.use(Vuex)



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-use-vuex/index.js
// module id = GdwN
// module chunks = 0